///// <reference path="../../../node_modules/metismenu/types/metismenu.d.ts" />

/*
Template Name: Material Pro Admin
Author: Themedesigner
Email: niravjoshi87@gmail.com
File: js
*/

module MaterialPro {
  "use strict";

  let jBody: JQuery<HTMLElement>;

  export function construct() {
    jBody = $("body");

    // this is for close icon when navigation open in mobile view
    $(".nav-toggler,.sidebartoggler").click(function () {
      jBody.toggleClass("show-sidebar");
      $(".nav-toggler i").toggleClass("ti-menu");
      $(".nav-toggler i").addClass("ti-close");
    });
  }
}